export const KEY_COMPONENTS = {
  PERSONAL_INFO_FORM: 'personalInfo',
  PASSPORT: 'passport',
  TRUSTEES: 'trustees',
  SPOUSE: 'spouse',
  LIVING_ADDRESS_PROPERTY: 'livingAddressProperty',
  SECOND_DOCUMENT: 'secondDocument',
  ADDRESS_REG: 'addressReg',
  ADDRESS_LIVE: 'addressLive',
  WORK: 'work',
  CONTACTS: 'contacts',
};

export const MARITAL_STATUS_IDS = {
  NO_STATE: 0,
  SINGLE_PERSON: 76,
  MARRIED_PERSON: 77,
  DIVORCED_PERSON: 78,
  WIDOW_PERSON: 79,
  CIVIL_MARRIAGE: 80,
};

export const PASSPORT_CONFIDENCE_ERRORS = {
  SERIA_NUMBER: 'passport.serianumber',
  ISSUE_DATE: 'passport.issueDate',
  ISSUE_CODE: 'passport.issuerCode',
  ISSUER: 'passport.issuer',
  BIRTHDAY_PLACE: 'passport.birthPlace',
  BIRTHDAY_DATE: 'personalInfo.birthDate',
};

export const ADDRESS_CONFIDENCE_ERRORS = {
  FIAS_VALUE: 'addressReg.fiasValue',
  REGISTRATION_DATE: 'addressReg.regDate',
};

export const ALERT_POPUP_TEXT = {
  MIDDLE_NAME: {
    title: 'Заполните ФИО чётко в соответствии\nc\u00A0паспортом',
    description: 'Если у вас отсутствует отчество нажмите Ok',
    agreeText: 'Ok',
  },
  FIO: {
    title: 'Ого! Кажется, мы по-другому распознали документы.',
    description: 'Проверьте, пожалуйста',
    agreeText: 'Ok',
  },
  DOCUMENT_TO_DELETE: {
    title: 'Вы действительно хотите удалить документ?',
    description: 'Документ удаляется безвозвратно',
    agreeText: 'Удалить',
  },
};
